import * as ActionTypes from '../ActionTypes';

export const asyncActions = (...actions) => {
  return (dispatch, getState) => {
    const rethrow = getState().general.get('rethrow');

    return actions
      .filter(a => a)
      .reduce((previousPromise, nextAsyncFunction) => {
        return previousPromise
          .then(() => dispatch(nextAsyncFunction));
      }, Promise.resolve())
      .catch(err => {
        dispatch(handleAsyncError(err));
        if (rethrow) throw(err);
      });
  }
}

export const clearErrors = () => ({
  type: ActionTypes.CLEAR_ERRORS
});

export const error = e => {
  return async (dispatch, getState) => {
    const session = getState().sessions.get('session');

    let parsedErr;
    let errorMsg;

    if (session) {
      dispatch(setDebugData('key', session.public_key));
      dispatch(setDebugData('workflow', session.workflow));
      dispatch(setDebugData('action', session.action));
    }

    // if we're getting unauthorized responses, expire the local data to force reauth
    if (e.status && e.status === 401) {
      pdExpire();
    // otherwise check for a json or text method
    } else if (e.json) {
      parsedErr = await e.json();
    } else if (e.text) {
      parsedErr = await e.text();
    } else {
      parsedErr = e;
    }

    errorMsg = e.statusText;
    if (parsedErr && parsedErr.error) errorMsg = (errorMsg + ' ' + parsedErr.error).trim();

    dispatch({
      type: ActionTypes.SET_ERROR,
      payload: errorMsg
    });

    if (!errorMsg || errorMsg === '') {
      errorMsg = 'DEFAULT ERROR MESSAGE';
    }
    
		console.error(e);
  }
};

export const setDebugData = (key, val) => ({
  type: ActionTypes.SET_DEBUG,
  payload: {
    key: key,
    value: val
  }
});

export const handleAsyncError = err => {
  return (dispatch, getState) => {
    dispatch(error(err));
  }
}

export const toggleRethrow = () => ({
  type: ActionTypes.TOGGLE_RETHROW
})
